import { Component } from '@angular/core';

@Component({
    selector: 'session-logged-out',
    templateUrl: './logged-out.component.html',
    styleUrls: ['./logged-out.component.scss'],
})
export class LoggedOutComponent {
}
